import { Box, Button, Chip, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { modalStyle } from "../../../../../../../../components/modalStyle";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import { changeOrderColumns } from "./changeOrderColumns";
import UpdateMrqBtn from "./UpdateMrqBtn";
import ChangeOrderTable from "../../../../CMS/ChangeOrderTable";
import { secondAxios } from "../../../../../../../../api/axios";
import { useParams } from "react-router-dom";

export default function ChangeOrderBtn({ row, previousDrawingRev, co }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { plantId } = useParams();

  const [data, setData] = useState([]);

  // console.log("Co chip", co);

  async function getCOs() {
    const res = await secondAxios.get(`/change-order/${co?.id}`);
    setData(res?.data?.id ? [res?.data] : []);
  }
  useEffect(() => {
    getCOs();
  }, []);

  // const rev = row.drawing?.revision;

  // const data = [];

  // row.drawing?.materials?.forEach((m) => {
  //   const prevMaterial = previousDrawingRev?.materials?.find(
  //     (pm) => pm.taggedMaterial?.tagNumber === m.tagNumber,
  //   );

  //   const prevMrq = prevMaterial?.mrqMaterials?.[0]?.mrq;

  //   const previousDescription = prevMaterial?.description || "";
  //   const selectedDescription = m?.description || "";

  //   if (!previousDescription) {
  //     data.push({
  //       ...m,
  //       previousDescription,
  //       previousQuantity: prevMaterial?.quantity,
  //       previousMrq: prevMrq
  //         ? prevMrq?.mrqNumber + `(Rev-${prevMrq?.rev})`
  //         : "",

  //       selectedDescription,
  //       selectedQuantity: m.quantity,
  //       selectedMrq: "",
  //       state: "new",
  //     });
  //   } else if (previousDescription !== selectedDescription) {
  //     data.push({
  //       ...m,
  //       previousDescription,
  //       previousQuantity: prevMaterial?.quantity,
  //       previousMrq: prevMrq
  //         ? prevMrq?.mrqNumber + `(Rev-${prevMrq?.rev})`
  //         : "",

  //       selectedDescription,
  //       selectedQuantity: m.quantity,
  //       selectedMrq: "",
  //       state: "updated",
  //     });
  //   }
  // });

  // previousDrawingRev?.materials?.forEach((pm) => {
  //   // Check if material exists in current drawing
  //   const currentMaterial = row.drawing?.materials?.find(
  //     (m) => m.tagNumber === pm.taggedMaterial?.tagNumber,
  //   );

  //   // If not found in current drawing, it's deleted
  //   if (!currentMaterial) {
  //     data.push({
  //       ...pm,
  //       previousDescription: pm?.description || "",
  //       previousQuantity: pm.quantity,
  //       previousMrq: pm?.mrqMaterials?.[0]?.mrq
  //         ? pm?.mrqMaterials?.[0]?.mrq?.mrqNumber +
  //           `(Rev-${pm?.mrqMaterials?.[0]?.mrq?.rev})`
  //         : "",

  //       selectedDescription: "",
  //       selectedQuantity: "",
  //       selectedMrq: "",
  //       state: "deleted",
  //     });
  //   }
  // });

  // console.log("data", previousDrawingRev);

  // const table = useMaterialReactTable({
  //   data,
  //   columns: changeOrderColumns({
  //     previousRevNumber: previousDrawingRev?.revision,
  //     currentRevNumber: row?.drawing?.revision,
  //   }),

  //   ...lightTable,
  // });

  return (
    <>
      {co?.coNumber && (
        <Chip
          onClick={handleOpen}
          // variant="outlined"
          icon={<ChangeCircleIcon />}
          label={co?.coNumber}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modalStyle, width: "95%" }}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Change Order ({co?.coNumber}) Details:
          </Typography>

          <Box>
            {/* <MaterialReactTable table={table} /> */}

            <ChangeOrderTable coTableData={data} />
          </Box>

          <Box
            sx={{
              mt: 2,

              textAlign: "right",
            }}
          >
            <Button
              color="error"
              variant="outlined"
              onClick={handleClose}
              sx={{ mx: 1 }}
              size="small"
            >
              Close
            </Button>

            <Button
              variant="contained"
              component="a"
              href={"/plant/" + plantId + "/cms"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go TO CMS
            </Button>
            {/* <UpdateMrqBtn parent="coModal" /> */}
          </Box>
        </Box>
      </Modal>
    </>
  );
}
